export default __webpack_public_path__ + "static/media/icon-delivery-celcom.73a8b1ce.svg";